import { Toast } from 'mint-ui'

export const regularToast = (message) => {
  Toast({
    message: message,
    position: 'middle',
    duration: 2500
  })
}
// 金额保留两位小数
export const MoneyTowPoint = (n) => {
  const s = String(n)
  if (s == 0 || s == '') return '0.00'
  if (!s) return 'invalid value'
  let value = Math.round(parseFloat(s) * 100) / 100
  let xsd = value.toString().split('.')
  if (xsd.length == 1) {
    value = value.toString() + '.00'
    return value
  }
  if (xsd.length > 1) {
    if (xsd[1].length < 2) {
      value = value.toString() + '0'
    }
    return value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/utilities.js